import { Portal } from "solid-js/web";
import { solidstate } from ":setup/qstate";
import { MetaContext } from "../SHARED/store";
import type { MainProps } from "./_model";
import { global } from ":shared/app";

export default function Meta(props: MainProps) {
  const app_id = global.store.actions.whitelabel.get;
  // const $meta = solidstate.create(props);

  // const $title = $meta.derive((f) => f.title[0].toUpperCase() + f.title.substring(1).toLowerCase());

  MetaContext.defaultValue = {
    setTitle(title) {
      // $meta.set({ title: props.title + " | " + title });
    },
  };
  return (
    <MetaContext.Provider value={MetaContext.defaultValue}>
      <Portal mount={document.head}>
        <title>{app_id().info.id}</title>
      </Portal>
      {props.children}
    </MetaContext.Provider>
  );
}
